import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMfrDosingRoller = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 8C10 7.44772 10.4477 7 11 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H11C10.4477 9 10 8.55228 10 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15H11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.00001 4C7.00001 3.44772 7.44772 3 8.00001 3H16C16.5523 3 17 3.44772 17 4V5.21432L20.761 5.99412C21.0797 6.06021 21.0797 6.47202 20.761 6.53811L17 7.31791V11.0642L20.761 11.844C21.0797 11.9101 21.0797 12.3219 20.761 12.388L17 13.1678V20C17 20.5523 16.5523 21 16 21H8.00001C7.44772 21 7.00001 20.5523 7.00001 20V19.0177L3.23904 18.2379C2.92032 18.1719 2.92032 17.76 3.23904 17.694L7.00001 16.9142V13.1678L3.23904 12.388C2.92032 12.3219 2.92032 11.9101 3.23904 11.844L7.00001 11.0642V4ZM9.00001 5V19H15V5H9.00001Z",
			fill: "currentColor"
		})
	]
});
export default SvgMfrDosingRoller;
